import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUndoUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-undo-up, back, top "} maskId="square-filled-radius-0-stroke-1-IconArrowUndoUp"><path d="M4.20726 8.5L7.70718 5.00008L7.00008 4.29297L2.29297 9.00008L7.00008 13.7072L7.70718 13.0001L4.20711 9.5H21V18H11.5V19H22V8.5H4.20726Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUndoUp;
